export default __webpack_public_path__ + "static/media/596.28c5ea32.jpg";